"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberMultipleCell = exports.NumberCell = void 0;
const react_1 = require("react");
const inline_table_field_cells_1 = require("../../../components/inline-table-field/inline-table-field-cells");
function NumberCell({ collectionDatakey, ...props }) {
    const Cell = inline_table_field_cells_1.InlineTableFieldCells.useInlineNumberFieldFactory({
        ...props,
        collectionDatakey,
    });
    return (0, react_1.useMemo)(() => Cell, [collectionDatakey]);
}
exports.NumberCell = NumberCell;
function NumberMultipleCell({ collectionDatakey, ...props }) {
    const Cell = inline_table_field_cells_1.InlineTableFieldCells.useInlineTextFieldMultipleFactory({
        ...props,
        type: 'number',
        collectionDatakey,
    });
    return (0, react_1.useMemo)(() => Cell, [collectionDatakey]);
}
exports.NumberMultipleCell = NumberMultipleCell;
//# sourceMappingURL=number-cell.js.map